// extracted by mini-css-extract-plugin
module.exports = {"permissionsWrapper":"style_permissionsWrapper__k9rBW","title":"style_title__x8Sf0"};